
import Google_PageView from "app/tracking/google/page_view"
import SaveManager from "concepts/listings/searches/saved/manager"

const init = () => {
  SaveManager.on("save_click:tracking", () => {
    Google_PageView.track([
      "/fake-path",
      "/apps/spacious-web-app",
      "/pages/all-pages",
      "/components/listing-filter-bar/save-filter-criteria-button",
      "/events/click",
    ].join(""))
  })
}
export default {init}
